import React from "react";

const SearchResults = ({ results, onSelect, alreadyAdded }) => {
  if (!results) return null;
  // console.log(alreadyAdded);
  if (results.length === 0) return (
    <div className="absolute top-full left-0 right-0 z-10 bg-p400 border border-n200 rounded-b-md shadow-lg max-h-60 overflow-y-auto no-scrollbar">
      <ul>
        <li className="p-3 text-sm text-n500">No results found</li>
      </ul>
    </div>
  );

  return (
    <div className="absolute top-full left-0 right-0 z-10 bg-p400 border border-n200 rounded-b-md shadow-lg max-h-60 overflow-y-auto no-scrollbar">
      <ul>
        {results.map((result, index) => (
          <li
            key={`${result.token}-${index}`}
            className="p-3 hover:bg-[#e0e0e0] cursor-pointer flex gap-2 items-center "
            onMouseDown={(e) => {
              e.preventDefault(); // Prevent the input from losing focus
              onSelect(result);
            }}>
            <div className="bg-n100 px-1 text-xs text-n500">
              {result.exch}
            </div>
            <div className="font-medium text-sm text-p150">{result.formatted_ins_name}</div>
            {/* if the symbol is already added, show a checkmark */}
            {alreadyAdded.includes(result.formatted_ins_name) && (
              <div className="ml-auto mr-2 flex items-center">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M5 11.5L9 15L15 7"
                    stroke="#22C55E"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchResults;
